
export const merlinSurveyId = 'merlin-survey-assistant';

export const surveyPageDemoSteps = [
  {
    target: `#${merlinSurveyId}`,
    id: 'isCustomer.merlin.demo-1',
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: `.question`,
    id: 'isCustomer.merlin.demo-2',
    disableBeacon: true
  },
  {
    target: `.progressBar`,
    id: 'isCustomer.merlin.demo-3',
    placement: 'top',
    disableBeacon: true
  },
  {
    target: `.page-navigation`,
    id: 'isCustomer.merlin.demo-4',
    placement: 'top',
    disableBeacon: true
  },
  {
    target: `#${merlinSurveyId}`,
    id: 'isCustomer.merlin.demo-5',
    placement: 'bottom',
    disableBeacon: true
  },
];

export default surveyPageDemoSteps;
